const DATE_TIME_ZONE = 'Asia/Kolkata';

export const formatDate = (dateString) => {
    if (!dateString) return '-';

    try {
        return new Intl.DateTimeFormat('en-GB', {
            timeZone: DATE_TIME_ZONE,
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(new Date(dateString));
    } catch (err) {
        return dateString;
    }
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '-';

    try {
        return new Intl.DateTimeFormat('en-GB', {
            timeZone: DATE_TIME_ZONE,
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).format(new Date(dateString)).replace(/\b(am|pm)\b/i, (match) => match.toLowerCase());
    } catch (err) {
        return dateString;
    }
};
